<template>
  <div class="confirm-heading-btn">
    <v-btn @click="openDialog()">見出し確認</v-btn>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-container>
          <v-row class="ml-2">
            <div v-if="headings.length !== 0">
              <div v-for="(heading, index) in headings" :key="index">
                <p>
                  {{ headingForDisplay(heading) }}
                </p>
              </div>
            </div>
            <div v-else>
              <p>この記事に見出しは存在しません</p>
            </div>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <v-btn
                color="success"
                class="mr-4"
                dark
                tile
                @click="copyHeadings()"
                >見出し一覧をコピー</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      dialog: false,
      headings: []
    }
  },
  computed: {
    ...mapState({
      items: (state) => state.PostEditor.post.items
    })
  },
  mounted () {
    this.fetchHeadings()
  },
  methods: {
    fetchHeadings () {
      this.headings = []
      this.items.forEach((item) => {
        if (!item._destroy && item.variety === 'heading') {
          this.headings.push(item.itemableAttributes)
        }
      })
    },
    openDialog () {
      this.dialog = true
      this.fetchHeadings()
    },
    headingForDisplay (heading) {
      return (
        '\b'.repeat(heading.headingType * 2 - 4) +
        `h${heading.headingType} ${heading.content}\n`
      )
    },
    headingsForDisplay () {
      let clipboardText = ''
      this.headings.forEach((heading) => {
        clipboardText += this.headingForDisplay(heading)
      })
      return clipboardText
    },
    copyHeadings () {
      if (!navigator.clipboard) {
        const payload = {
          status: 500,
          message:
            'clipboardAPIを利用するために、https環境で実行してください。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }
      this.$store.dispatch('LoaderStore/displayLoader')

      navigator.clipboard
        .writeText(this.headingsForDisplay())
        .then(
          () => {
            const payload = {
              status: 200,
              message: '保存済みの記事の内容をクリップボードにコピーしました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: 500,
              message: `コピーできませんできませんでした（${error}）`
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>

<style scoped lang="sass">
.confirm-heading-btn
  margin-right: 40px
</style>
